import {Component, signal, ViewEncapsulation} from '@angular/core';
import {constants} from '@q9elements/ui-kit/common';

import {ImpactAssessmentTreeService} from '../../services/impact-analysis-tree.service';

@Component({
  selector: 'app-impact-tree-toolbar',
  templateUrl: './impact-tree-toolbar.component.html',
  styleUrls: ['./impact-tree-toolbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImpactTreeToolbarComponent {
  readonly dependencyTreeHelpLink = constants.helpChartsLinks.dependencyTreeHelpLink;
  public readonly openTips = signal(false);

  constructor(private impactAssessmentTreeService: ImpactAssessmentTreeService) {}

  public zoomIn() {
    this.impactAssessmentTreeService.emitZoomEvent(2);
  }

  public zoomOut() {
    this.impactAssessmentTreeService.emitZoomEvent(0.5);
  }

  public toggleTips() {
    this.openTips.update(value => !value);
  }
}
